<app-dialog
  header="Track All Controlled Substances and Drugs of Interest?"
  subHeader=""
  [maxWidth]="700"
  [saveBtnMinWidth]="160"
  [headerIcon]="'warning'"
  [show]="step === EnableC3C5WorkflowStepsEnum.AdditionalChargeDialog"
  [hasControls]="true"
  saveBtnText="Continue Activation"
  [hideHeaderUnderline]="true"
  headerIconName="icon-exclamation-triangle2"
  [disableSaveBtn]="loading$ | async"
  (cancel)="cancel.emit()"
  (save)="step = EnableC3C5WorkflowStepsEnum.SelectDrugActivity">
   <span>Note the following important details about this feature. For further clarification, contact your C2 Keep rep.</span>
  <div class="p-4 font-normal ml-2">
    <ul class="list-disc leading-relaxed">
      <li>This requires the C2 Keep Plus or C2 Keep Enterprise plan, resulting in additional charges.</li>
      <li>Once activated, you cannot revert back to the C2 Keep Regular plan.</li>
      <li>Once activated, you can track & report CIIIs, CIVs, CVs, gabapentin, and pseudoephedrine activities.</li>
      <li>Once activated, you may deactivate the feature to stop tracking only. This is not recommended for compliance reasons.</li>
      <li>Make sure you have a payment option setup in your customer portal before proceeding.</li>
    </ul>
  </div>
  <span>How would you like to proceed?</span>
</app-dialog>

<app-dialog
  header="Please select which drug schedules to track"
  subHeader=""
  [maxWidth]="576"
  [minWidth]="576"
  [show]="step === EnableC3C5WorkflowStepsEnum.SelectDrugActivity"
  [hasControls]="true"
  [hideHeaderUnderline]="true"
  [hideControlsDivider]="true"
  saveBtnText="Continue"
  (cancel)="cancel.emit()"
  (save)="saveSelected()">
  <div class="inputs-container" [formGroup]="form">
    <div class="">
      <app-options-list
        formControlName="activity"
        [optionsList]="activityToTrackList"
        [hasCustomTemplate]="true"
        [borderedNoBackground]="true"
      >
      <ng-template let-option let-i="idx">
         <div class="template">
            <div>{{option.name}}</div>
            <div class="description">{{option.description}}</div>
            <ul class="description list-disc ml-6 pt-2">
              <li *ngFor="let item of option.descriptionList">{{item}}</li>
            </ul>
         </div>
      </ng-template>
    </app-options-list>
    </div>
  </div>
</app-dialog>

<app-dialog
  header="Confirm Drugs of Interest"
  subHeader="Please confirm the following drugs of interest you’d like to track"
  [maxWidth]="576"
  [minWidth]="576"
  [show]="step === EnableC3C5WorkflowStepsEnum.CustomizeNdcList"
  [hasControls]="true"
  [hideHeaderUnderline]="true"
  [hideControlsDivider]="true"
  saveBtnText="Confirm"
  (cancel)="cancelPickingDrugsOfInterest()"
  (save)="confirmCustomDrugsList()">
  <div class="checkbox-container" [formGroup]="form">
    <app-checkbox class="block mb-2"
      *ngFor="let item of customDrugsList; let i = index"
      (change)="drugOptionsChanged(item.id)"
      [id]="i"
      [checked]="isSelected(item.id)"
    >
      <span class="cursor-pointer text-sm text-gray-900 font-medium"
        [ngClass]="{active: isSelected(item.id)}"
      >{{item.name}}</span>
    </app-checkbox>
  </div>
</app-dialog>